export default __webpack_public_path__ + "static/media/Theme18.488e0223.png";